<template>
    <vueCustomScrollbar v-if="listMember.length > 0" class="list-member">
        <b-table striped hover :fields="fieldsTableMember" :items="listMember">
            <template #head(stt)="data">
                <span class="col-table">{{ data.label }}</span>
            </template>

            <template #head(name)="data">
                <span class="col-table">{{ data.label }}</span>
            </template>

            <template #head(action)="data">
                <span @click="handleAddMember" class="text-btn-add-member">{{ data.label.toUpperCase() }}</span>
            </template>
            <template #cell(name)="data">
                <router-link :to="{ path: 'thong-ke-hoc-sinh', query: { userId: data.item.userId } }" target="_blank"
                    class="text-default m-0 p-0">
                    <span class="text-primary">{{ data.item.name }}</span>
                </router-link>
            </template>
            <template #cell(action)="row">
                <span @click="handleChangeNameMember(row)" class="mr-1 btn-edit">
                    Sửa
                </span>
                /
                <span @click="handleDeleteMember(row)" class="mr-1 btn-delete">
                    Xóa
                </span>
            </template>
        </b-table>
        <ModalChangeNameMemberClassSchool v-if="isShowModalChangeNameClassSchool" :item="itemSelected"
            @closeModal="closeModalChangeNameMember" @handleDone="handleDoneChangeName" />
        <ModalDeleteUserClassSchool v-if="isOpenModalDeleteUserClassSchool" @closeModal="closeModalDeleteMember"
            :item="itemSelected" @handleDeleteDone="handleDeleteDone" />
    </vueCustomScrollbar>
    <div v-else class="list-member">
        Không có học sinh nào trong lớp
    </div>
</template>
<script>
import ModalDeleteUserClassSchool from './../../_components/ModalDeleteUserClassSchool.vue'
import ModalChangeNameMemberClassSchool from './../../_components/ModalChangeNameMemberClassSchool.vue';
import { getAllMemberInClassSchoolService } from './../../_api/classSchoolUserServices'
import vueCustomScrollbar from "vue-custom-scrollbar";
export default {
    components: {
        ModalChangeNameMemberClassSchool,
        ModalDeleteUserClassSchool,
        vueCustomScrollbar
    },
    data() {
        return {
            classSchoolId: 0,
            listMember: [],
            isShowModalChangeNameClassSchool: false,
            fieldsTableMember: [
                { key: 'stt', label: 'STT', thClass: 'w-60px text-center', tdClass: 'w-60px text-center' }, 
                { key: 'name', label: 'Họ tên học sinh' }, 
                { key: 'action', label: '' }],
            itemSelected: {},
            isOpenModalDeleteUserClassSchool: false
        }
    },
    mounted() {
        this.classSchoolId = this.$route.query.id
        this.getAllMemberInClassSchool()
    },
    methods: {
        handleDeleteDone() {
            this.getAllMemberInClassSchool()
            this.closeModalDeleteMember()
        },
        closeModalDeleteMember() {
            this.isOpenModalDeleteUserClassSchool = false
        },
        handleDoneChangeName() {
            this.getAllMemberInClassSchool()
            this.closeModalChangeNameMember()
        },
        closeModalChangeNameMember() {
            this.isShowModalChangeNameClassSchool = false
        },
        handleAddMember() {
            this.$emit('handleAddMember')
        },
        handleChangeNameMember(row) {
            this.itemSelected = row.item
            this.isShowModalChangeNameClassSchool = true
        },
        handleDeleteMember(row) {
            this.itemSelected = row.item
            this.isOpenModalDeleteUserClassSchool = true
        },
        getAllMemberInClassSchool(paramQuery = {
            keyword: '',
            gender: 0
        }) {
            this.listMember = []
            let query = {
                classSchoolId: this.classSchoolId,
                keyword: paramQuery.keyword,
                gender: paramQuery.gender
            }
            getAllMemberInClassSchoolService(query).then((res) => {
                if (res && res.data && !res.errors) {
                    for (let i = 0; i < res.data.length; i++) {
                        const item = res.data[i];
                        this.listMember.push({ 'id': item.id, 'stt': i + 1, 'name': item.userName, userId: item.userId })
                    }
                }
            })
        },
    }
}
</script>


<style lang="scss" scoped>
.btn-edit {
    color: #8ba3f9;
    cursor: pointer;
}

.btn-delete {
    color: red;
    cursor: pointer;
}

.text-btn-add-member {
    font-size: 12px;
    color: #4eec43;
}
.table th {
  padding: 0.5rem 0.75rem;
}
.table td {
  padding: 0.5rem 0.75rem;
}
.list-member {
    max-height: 26rem;
    overflow-y: auto;
}
</style>